export const UPDATE_DATA = 'UPDATE_DATA';
export const FILTER_DATA = 'FILTER_DATA';
export const PAGE_CHANGE = 'PAGE_CHANGE';
export const TOTAL_DOC_COUNT = 'TOTAL_DOC_COUNT';
export const UPDATE_FILTER_FIELD = 'UPDATE_FILTER_FIELD';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const GET_WEBSITE_URLS = 'GET_WEBSITE_URLS';
export const CHANGE_NEIGHBORHOOD = "CHANGE_NEIGHBORHOOD";
export const CHANGE_PROJECT = "CHANGE_PROJECT";
export const CHANGE_DOCUMENT = "CHANGE_DOCUMENT";
export const ALL_WEB_URL_DATA = "ALL_WEB_URL_DATA";
export const DEFAULT_FILTERS = "DEFAULT_FILTERS";
export const SET_FILTERS = "SET_FILTERS";
export const SEARCH_TEXT_FILTER = 'SEARCH_TEXT_FILTER';
